import CoordinatorService from "../services/CoordinatorService";
import router from "@/router";

const uuidv4 = require("uuid/v4");

const getDefaultState = () => ({
  count: 0,
  user: {
    uuid: "",
    user_name: "",
    email: "",
    admin: false,
    password: "",
    confirm: "",
  },
  coordinator: {
    uuid: "",
    active: true,
    first_name: "",
    middle_name: "",
    last_name: "",
    designation: "",
    sex: "",
    dob: null,
    mobile_1: "",
    mobile_2: "",
    email: "",
    country: "",
    region: "",
    district: "",
    village: "",
    address: "",
    course_name: "",
    date_comp: "",
    institution: "",
    trainer_uuid: "",
  },
  observation: {
    id: null,
    obs_date: null,
    school_id: "",
    coordinator_id: "",
    teacher_id: "",
    coordinator_uuid: "",
    teacher_uuid: "",
    implemented: false,
    recommendation: "",
  },
  observations: [],
  coordinators: [],
  coordinatorsExport: [],
  coordinatorTeams: [],
  schoolTeachers: [],
  coordinatorSchoolNames: [],
  coordinatorTrainers: [],
  coordinatorSchoolsTeachers: [],
  coordinatorSchoolsTeachersNames: [],
  teachersArray: [],
  coordinatorModules: [],
  teachersWorkshops: [],
});

const coordinators = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    userName(state, val) {
      state.user.user_name = val;
    },
    userEmail(state, val) {
      state.user.email = val;
    },
    password(state, val) {
      state.user.password = val;
    },
    confirm(state, val) {
      state.user.confirm = val;
    },
    count(state, val) {
      state.count = val;
    },
    active(state, val) {
      state.coordinator.active = val;
    },
    first_name(state, val) {
      state.coordinator.first_name = val;
    },
    middle_name(state, val) {
      state.coordinator.middle_name = val;
    },
    last_name(state, val) {
      state.coordinator.last_name = val;
    },
    dob(state, val) {
      state.coordinator.dob = val;
    },
    sex(state, val) {
      state.coordinator.sex = val;
    },
    designation(state, val) {
      state.coordinator.designation = val;
    },
    mobile_1(state, val) {
      state.coordinator.mobile_1 = val;
    },
    mobile_2(state, val) {
      state.coordinator.mobile_2 = val;
    },
    email(state, val) {
      state.coordinator.email = val;
    },
    country(state, val) {
      state.coordinator.country = val;
    },
    region(state, val) {
      state.coordinator.region = val;
    },
    district(state, val) {
      state.coordinator.district = val;
    },
    village(state, val) {
      state.coordinator.village = val;
    },
    address(state, val) {
      state.coordinator.address = val;
    },
    course_name(state, val) {
      state.coordinator.course_name = val;
    },
    date_comp(state, val) {
      state.coordinator.date_comp = val;
    },
    institution(state, val) {
      state.coordinator.institution = val;
    },
    trainer_uuid(state, val) {
      state.coordinator.trainer_uuid = val;
    },
    observationDate(state, val) {
      state.observation.obs_date = val;
    },
    observationCoordinator(state, val) {
      state.observation.date = val;
    },
    observationSchool(state, val) {
      state.observation.school_id = val;
    },
    observationTeacher(state, val) {
      state.observation.teacher_id = val;
    },
    observationRecommendation(state, val) {
      state.observation.recommendation = val;
    },
    observationImplemented(state, val) {
      state.observation.implemented = val;
    },
    observations(state, val) {
      state.observations = val;
    },
    coordinatorSchools(state, val) {
      state.coordinatorSchools = val;
    },
    schoolTeachers(state, val) {
      state.schoolTeachers = val;
    },
    coordinatorTeams(state, val) {
      state.coordinatorTeams = val;
    },
    coordinatorTrainers(state, val) {
      state.coordinatorTrainers = val;
    },
    coordinatorSchoolNames(state, val) {
      state.coordinatorSchoolNames = val;
    },
    coordinatorTeachers(state, val) {
      state.coordinatorTeachers = val;
    },
    coordinatorSchoolsTeachers(state, val) {
      state.coordinatorSchoolsTeachers = val;
    },
    coordinatorSchoolsTeachersNames(state, val) {
      state.coordinatorSchoolsTeachersNames = val;
    },
    teachersArray(state, val) {
      state.teachersArray = val;
    },
    coordinatorModules(state, val) {
      state.coordinatorModules = val;
    },
    teachersWorkshops(state, val) {
      state.teachersWorkshops = val;
    },
    resetCoordinators(state) {
      Object.assign(state, getDefaultState());
    },
    resetList(state) {
      state.perPage = 10;
      state.currentPage = 1;
    },
  },
  actions: {
    async RESET_COORDINATORS_STATE(context) {
      await context.commit("resetCoordinators");
    },
    async GET_COORDINATOR_COUNT(context) {
      const res = await CoordinatorService.fetchCoordinatorCount();
      const { count } = res.data.results;
      context.commit("count", parseInt(count));
    },
    async CREATE_COORDINATOR({ state }) {
      const coordinatorData = {
        ...state.coordinator,
      };
      const userData = {
        ...state.user,
      };
      const key = "dob";
      const key2 = "date_comp";
      coordinatorData.birthdate = state.coordinator[key];
      coordinatorData.date_completed = state.coordinator[key2];
      delete coordinatorData[key];
      delete coordinatorData[key2];
      delete userData.confirm;
      if (coordinatorData.birthdate === "") {
        coordinatorData.birthdate = null;
      }
      if (coordinatorData.date_completed === "") {
        coordinatorData.date_completed = null;
      }
      userData.uuid = uuidv4();
      coordinatorData.uuid = uuidv4();
      await CoordinatorService.addCoordinator(userData, coordinatorData);
    },
    async GET_COORDINATORS(context) {
      const res = await CoordinatorService.fetchCoordinators();

      const data = await res.data.coordinators;
      context.rootState.coordinators.coordinators = data;
    },
    async GET_COORDINATORS_EXPORT(context) {
      const res = await CoordinatorService.fetchCoordinatorsExport();
      const data = await res.data.coordinators;
      context.rootState.coordinators.coordinatorsExport = data;
    },
    async GET_COORDINATOR(context) {
      const coordinator = await CoordinatorService.getCoordinator({
        uuid: router.currentRoute.params.id,
      });
      const data = await coordinator.data.coordinator[0];
      context.rootState.coordinators.coordinator = data;
    },
    async UPDATE_COORDINATOR({ state }) {
      const key = await "dob";
      const key2 = await "date_comp";
      state.coordinator.birthdate = await state.coordinator[key];
      state.coordinator.date_completed = await state.coordinator[key2];
      await delete state.coordinator[key];
      await delete state.coordinator[key2];
      await CoordinatorService.updateCoordinator(state.coordinator);
    },
    async GET_SCHOOL_NAMES_BY_COORDINATOR(context) {
      const schools = await CoordinatorService.fetchSchoolNamesByCoordinator({
        id: router.currentRoute.params.id,
      });
      const data = schools.data.schools;
      context.commit("coordinatorSchoolNames", data);
    },
    async GET_COORDINATOR_TEAMS(context) {
      const teams = await CoordinatorService.fetchCoordinatorTeams({
        id: router.currentRoute.params.id,
      });
      const data = teams.data.teams;
      // console.log(data);
      context.commit("coordinatorTeams", data);
    },
    async GET_COORDINATOR_TRAINERS(context) {
      const trainers = await CoordinatorService.fetchCoordinatorTrainers({
        id: router.currentRoute.params.id,
      });
      const data = trainers.data.trainers;
      context.commit("coordinatorTrainers", data);
    },
    async GET_COORDINATOR_TEACHERS(context) {
      const teachers = await CoordinatorService.fetchCoordinatorTeachers({
        id: router.currentRoute.params.id,
      });
      const data = teachers.data.teachers;
      context.commit("coordinatorTeachers", data);
    },
    async GET_COORDINATOR_SCHOOLS_TEACHERS(context) {
      const teachers = await CoordinatorService.fetchCoordinatorSchoolsTeachers(
        {
          id: router.currentRoute.params.id,
        }
      );
      const data = teachers.data.teachers;
      context.commit("coordinatorSchoolsTeachers", data);
    },
    async GET_TEACHER_NAMES_BY_COORDINATOR_SCHOOL(context, id) {
      const teachers = await CoordinatorService.fetchTeacherNamesByCoordinatorSchool(
        id
      );
      const data = teachers.data.teachers;
      context.commit("schoolTeachers", data);
    },
    async GET_COORDINATOR_OBSERVATIONS(context) {
      const res = await CoordinatorService.fetchCoordinatorObservations({
        id: router.currentRoute.params.id,
      });

      const data = await res.data.observations;
      context.commit("observations", data);
    },
    async GET_COORDINATOR_MODULES(context) {
      const modules = await CoordinatorService.fetchCoordinatorModules({
        id: router.currentRoute.params.id,
      });
      const data = modules.data.results;
      context.commit("coordinatorModules", data);
    },
    async GET_COORDINATOR_SCHOOLS(context) {
      const schools = await CoordinatorService.fetchCoordinatorSchools({
        id: router.currentRoute.params.id,
      });
      const data = schools.data.schools;
      context.commit("coordinatorSchools", data);
    },
    async GET_TEACHER_WORKSHOPS(context) {
      const workshops = await CoordinatorService.fetchCoordinatorTeacherWorkshops(
        {
          id: router.currentRoute.params.id,
        }
      );
      const data = workshops.data.results;
      context.commit("teachersWorkshops", data);
    },
  },
  getters: {
    getCoordinators: (state) => state.coordinators,
  },
};

export default coordinators;
